import { render } from "./MenuContentItemValueTel.vue?vue&type=template&id=a4d639b6"
import script from "./MenuContentItemValueTel.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueTel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__